type EventHandler<T extends React.SyntheticEvent> = (event: T) => void;

export function callAllHandlers<T extends React.SyntheticEvent>(
  ...fns: Array<EventHandler<T> | undefined>
) {
  return function (event: T) {
    fns.forEach((fn) => {
      if (fn) {
        fn(event);
      }
    });
  };
}
